module.exports = __webpack_public_path__ + "img/28-logo.099a8bdd.png";